"use strict";
/**
 * Created by aghavni.grigoryan on 3/28/2018.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const Subscription_1 = require("rxjs/Subscription");
const idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
const idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
const Subject_1 = require("rxjs/Subject");
const operators_1 = require("rxjs/operators");
const EmptyObservable_1 = require("rxjs/observable/EmptyObservable");
class ReportingControlsCommonLogic {
    constructor(_activatedRoute, communicationService, pageFilterService) {
        this._activatedRoute = _activatedRoute;
        this.communicationService = communicationService;
        this.pageFilterService = pageFilterService;
        /**
         * Indicates if report is valid and has data to render
         */
        this.hasData = false;
        /**
         * Indicates if report is valid
         */
        this.isValid = false;
        this.reportingError = false;
        this.validationMessage = null;
        this.isOrientable = false;
        this.subscribedToPageFilterChange = false;
        this.subscriptions = new Subscription_1.Subscription();
        this.destroy$ = new Subject_1.Subject();
    }
    ngOnDestroy() {
        this.clearSubscriptions();
        this.destroy$.next(true);
        this.destroy$.complete();
    }
    /**
     * Creates drill down data based on categories and series for pie and categorical charts,
     * combines all filters (page filters, chart filters and selected category and series filters).
     * Passes that data to dynamic pages via communication service {@see CommunicationService}
     * @param goToData - data of clicked item
     */
    goToPageFromDrillDown(goToData) {
        let drillDownData;
        let drillDownItems = [];
        let currentDrillDownItem = null;
        let categories = this.chartData.categoriesMap || new Map().set(undefined, undefined);
        let drillDownItemIndex = 0;
        const chartSeries = this.chartData.categoriesMap && !this.selectedSeriesId ? this.chartData.series.slice(0, 1) : this.chartData.series;
        categories.forEach((categoriesName, categoriesId) => {
            chartSeries.forEach((chartDataItem) => {
                const filterBuilder = idm_reporting_service_client_js_1.FilterDtoBuilder.createAndFilterBuilder();
                let categoryFilter;
                let seriesFilter;
                if (categoriesId === -1) { // when category or series is 'Other'
                    categoryFilter = new Set(Array.from(categories.keys()).filter((seriesId) => seriesId !== -1));
                    if (this.selectedSeriesId && chartDataItem.seriesId === -1) {
                        seriesFilter = new Set(this.chartData.series.map((seriesItem) => seriesItem.seriesId).filter((seriesId) => seriesId !== -1));
                        filterBuilder
                            .filterByCategory(this.selectedCategoryId).not().in(categoryFilter)
                            .andCategory(this.selectedSeriesId).not().in(seriesFilter);
                    }
                    else {
                        filterBuilder
                            .filterByCategory(this.selectedCategoryId).not().in(categoryFilter);
                    }
                }
                else if (chartDataItem.categoryId === -1) { // when category is 'Other'
                    categoryFilter = new Set(this.chartData.series.map((seriesItem) => seriesItem.categoryId).filter((seriesId) => seriesId !== -1));
                    filterBuilder
                        .filterByCategory(this.selectedCategoryId).not().in(categoryFilter);
                }
                else {
                    categoryFilter = new Set().add(categoriesId === undefined ? chartDataItem.categoryId : categoriesId);
                    seriesFilter = new Set().add(chartDataItem.seriesId);
                    if (this.selectedSeriesId) {
                        filterBuilder
                            .filterByCategory(this.selectedCategoryId).in(categoryFilter)
                            .andCategory(this.selectedSeriesId).in(seriesFilter);
                    }
                    else {
                        filterBuilder.filterByCategory(this.selectedCategoryId).in(categoryFilter);
                    }
                }
                let filterTreeDto = idm_reporting_service_client_js_1.FilterDtoBuilder.combineAnd(this.allFiltersTreeDto, filterBuilder.build());
                let drillDownCategoryName = `${this.categoryMeasurePaths.categoryPaths.get(+this.selectedCategoryId).name.get(this.currentLanguageId)} : 
                                                        ${categoriesName != null ? categoriesName : chartDataItem.category}`;
                let drillDownSeriesName = this.selectedSeriesId ?
                    `${this.categoryMeasurePaths.categoryPaths.get(+this.selectedSeriesId).name.get(this.currentLanguageId)} : ${chartDataItem.name}`
                    : null;
                let drillDownItem = {
                    id: ++drillDownItemIndex,
                    categoryName: drillDownCategoryName,
                    seriesName: drillDownSeriesName,
                    filters: filterTreeDto.toJson()
                };
                if ((categoriesId === undefined ? chartDataItem.categoryId : categoriesId) === goToData.categoryId && chartDataItem.seriesId == goToData.seriesId) {
                    currentDrillDownItem = drillDownItem;
                }
                else {
                    drillDownItems.push(drillDownItem);
                }
            });
        });
        drillDownData = {
            pageId: goToData.pageId,
            currentDrillDownItem: currentDrillDownItem,
            drillDownItems: drillDownItems
        };
        let message = new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.DRILL_DOWN_CLICK, drillDownData);
        this.communicationService.parentSubject.next(message);
    }
    /**
     * Updates filters according to provided filters from page and form.
     * @param filters - page filters
     * @param filterTreeDto - our filter
     * @param systemName - entity category system name from forms
     * @param id - entity instance id from forms
     * @param root - root category path if it exists
     */
    updateFilters(filters = [], filterTreeDto, systemName, id, root) {
        if (typeof filters === 'string') {
            filters = JSON.parse(filters);
        }
        if (systemName && id) {
            !filters && (filters = []);
            filters.push({ systemName: systemName, items: [id] });
        }
        if (Array.isArray(filters) && filters.length > 0) {
            const systemNamePathIds = this.createCategorySystemNamePathIdsMap();
            filters.forEach((filter) => {
                const pathIds = systemNamePathIds.get(filter.systemName);
                const filterBuilder = idm_reporting_service_client_js_1.FilterDtoBuilder.createOrFilterBuilder();
                if (root && pathIds.includes(root.id)) {
                    filterBuilder.filterByCategory(root.id).in(filter.items);
                }
                else {
                    pathIds.forEach((id) => {
                        filterBuilder.filterByCategory(id).in(filter.items);
                    });
                }
                filterTreeDto = idm_reporting_service_client_js_1.FilterDtoBuilder.combineAnd(filterTreeDto, filterBuilder.build());
            });
        }
        if (!Array.isArray(filters) && typeof filters === 'object' && filters) {
            filterTreeDto = idm_reporting_service_client_js_1.FilterDtoBuilder.combineAnd(filterTreeDto, filters);
        }
        return filterTreeDto;
    }
    createCategorySystemNamePathIdsMap() {
        const systemNamePathIds = new Map();
        this.categoryMeasurePaths.categoryPaths.forEach((categoryPath) => {
            if (!systemNamePathIds.has(categoryPath.metaCategoryId.systemName)) {
                systemNamePathIds.set(categoryPath.metaCategoryId.systemName, [categoryPath.id]);
            }
        });
        return systemNamePathIds;
    }
    /**
     * Subscribe to listens to page filter changes and redraw the view
     * When page filter service is not present, or when already subscribed to page filter changes, just redraw the view.
     * @protected
     */
    redrawWithSubscribeToPageFilterChange() {
        if (this._activatedRoute && this.pageFilterService && !this.subscribedToPageFilterChange) {
            this.subscribedToPageFilterChange = true;
            this._activatedRoute.params
                .pipe(operators_1.take(1), operators_1.switchMap((params) => {
                this.pageId = params["pageId"];
                this.pageFilterService.requestPageFilter();
                return this.pageFilterService.getFilterChange();
            }), operators_1.takeUntil(this.destroy$))
                .subscribe((filtersMap) => {
                if (this.pageId && filtersMap && filtersMap.has(this.pageId)) {
                    this.refreshView(filtersMap.get(this.pageId));
                }
                else {
                    // reset page filter old value if some exists
                    this.pageFilterTreeDto = null;
                    this.redraw();
                }
            });
        }
        else {
            if (!this.pageFilterTreeDto && this.pageFilterService && this.pageId && this.dataSetId) {
                let datasetFilterTreeDto = this.pageFilterService.getLatestFilterMap().get(this.pageId);
                datasetFilterTreeDto && (this.pageFilterTreeDto = datasetFilterTreeDto.get(this.dataSetId));
            }
            this.redraw();
        }
    }
    /**
     * Sends export data to parent (page) for page export
     * @protected
     */
    sendWidgetExportData() {
        const exportData = {
            id: this.id,
            title: this.widgetTitle,
            isOrientable: this.isOrientable,
            getExportDto: this.getExportDto.bind(this)
        };
        const message = new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.WIDGET_EXPORT_DATA, exportData);
        this.communicationService.parentSubject.next(message);
    }
    /**
     * Returns report title, if it is empty, returns untitled message
     * @protected
     */
    getWidgetTitle() {
        return (this.reportTitle && this.reportTitle.getValue(this.currentLanguageId)) || this.untitledMessage;
    }
    /**
     * Unsubscribes from the observable to clean up the state.
     * @private
     */
    clearSubscriptions() {
        if (this.subscriptions) {
            this.subscriptions.unsubscribe();
        }
        this.subscriptions = null;
    }
    reportingErrorHandler() {
        this.reportingError = true;
        this.isValid = false;
        return EmptyObservable_1.EmptyObservable.create();
    }
}
ReportingControlsCommonLogic.NO_DATA_MESSAGE = 'reporting.controls.chart-designer.placeholder.noData';
ReportingControlsCommonLogic.DRILL_DOWN_MESSAGE = 'reporting.controls.chart-designer.text.goToTab';
exports.ReportingControlsCommonLogic = ReportingControlsCommonLogic;
//# sourceMappingURL=reporting-controls-common-logic.js.map